// @flow

import * as R from "ramda";
import {
	A,
	FlexCol,
	FlexRow,
	Header,
	Left,
	Title,
	Wrapper,
} from "./Popup.styles";
import { Button, Image } from "../common";
import React from "react";
import logos from "views/resources/logos/SVG";
import moment from "moment-timezone";
import type { HourBlock, Office } from "types";

interface Props {
	office: Office;
	hourBlock: HourBlock;
	onClick(): void;
}

const formatTime = (timezone, date) =>
	moment.tz(date, timezone).clone().format("HH:mm");
const formatDate = (timezone, date) =>
	moment.tz(date, timezone).clone().format("ll");

// Confirmation popup
const ReservationPopup = ({
	office,
	hourBlock,
	isLoading,
	onClick,
	close,
	category,
	v2,
	timezone,
}: Props) => {
	const { from, to } = hourBlock;
	const date = v2 ? formatDate(timezone, from) : hourBlock.from.format("ll");
	const displayFrom = v2 ? formatTime(timezone, from) : from.format("HH:mm");
	const displayTo = v2 ? formatTime(timezone, to) : to.format("HH:mm");
	const logo = R.pathOr(false, ["options", "brand", "logo"], office);
	const showLogo = R.pathOr(false, ["options", "brand", "show_logo"], office);
	const handleOnClick = () => {
		onClick();
		close();
	};

	return (
		<Wrapper>
			<FlexCol>
				<FlexRow>
					<Left>
						<Image>
							<img
								src={
									showLogo
										? logo
										: logos[
												`logo_${office.category_id}_color`
										  ]
								}
								alt={office.name}
							/>
						</Image>
					</Left>
					<Title>{office.name}</Title>
				</FlexRow>
				<Header>Día y hora de reserva:</Header>
				<h2>
					{date} / {displayFrom}
				</h2>
				<p>
					Revisa bien el día y la hora de reserva. Recuerda llegar con
					10 minutos de anticipación
				</p>
				<Button
					color="secondary"
					size="full"
					isLoading={isLoading}
					onClick={handleOnClick}
				>
					Confirmar reserva
				</Button>
				<A onClick={close}>
					<small>Elegir otro día y hora</small>
				</A>
			</FlexCol>
		</Wrapper>
	);
};

export default ReservationPopup;
